export const advisorAllowedRoutes = [
  '/peer-directory',
  '/dashboard',
  '/account',
  '/advisor/onboarding/terms-of-service',
  '/advisor/aobf',
  '/advisor/aobf-loading',
  '/advisor/aobf/step2',
  '/advisor/aobf/step3',
  '/advisor/aobf/step4',
  '/board-directory',
  '/post/:postId?',
  '/networking',
  '/:companySlug/post/:postId?',
  '/:companySlug/boardroom',
  '/:companySlug/benefits',
  '/:companySlug/posts',
  '/faqs',
  '/tools-resources',
  '/upgrade-and-services',
  '/success-stories',
  '/ub',
  '/wf',
  '/messages',
];
